import { ErrorMessage } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './ErrorState.styles';

interface ErrorStateProps {
  onClick: () => void;
}

export const ErrorState = ({ onClick }: ErrorStateProps) => {
  const { t } = useTranslation('widget');

  return (
    <S.ErrorStateRoot>
      <ErrorMessage
        title={<S.Title>{t('widget:watchlist.errorLabel')}</S.Title>}
        subtitle=""
        buttonProps={{
          label: t('widget:watchlist.summarize'),
          iconName: 'Summarise',
          onClick,
        }}
      />
    </S.ErrorStateRoot>
  );
};
